import { authenticationConstants } from "../_constants/authentication.constants";

export const toggleSignInModal = () => ({
  type: authenticationConstants.TOGGLED_SIGN_IN_MODAL,
});

export const toggleErrorMessageModal = () => ({
  type: authenticationConstants.TOGGLED_ERROR_MESSAGE_MODAL,
});

export const refreshToken = () => ({
  type: authenticationConstants.REFRESH_TOKEN,
});

export const signInStart = (credential) => ({
  type: authenticationConstants.SIGN_IN_START,
  payload: credential,
});

export const verify2FAOpen = (referenceCode) => ({
  type: authenticationConstants.VERIFY_2FA_OPEN,
  payload: referenceCode,
});

export const toggle2FAModal = () => ({
  type: authenticationConstants.TOGGLED_2FA_MODAL,
});

export const verify2FAStart = (credential) => ({
  type: authenticationConstants.VERIFY_2FA_START,
  payload: credential,
});

export const set2FALoading = (isLoading) => ({
  type: "SET_2FA_LOADING",
  payload: isLoading,
});

export const signInSuccess = (user) => ({
  type: authenticationConstants.SIGN_IN_SUCCESS,
  payload: user,
});

export const signInFailure = (errorMessage) => ({
  type: authenticationConstants.SIGN_IN_FAILURE,
  payload: errorMessage,
});

export const clearSignInErrorMessage = () => ({
  type: authenticationConstants.CLEAR_SIGN_IN_ERROR_MESSAGE,
});

// Sign in with credential with window authentication.
export const signInCredentialStart = (data) => ({
  type: authenticationConstants.SIGN_IN_CREDENTIAL_START,
  payload: data,
});

export const signInDSAStart = (data) => ({
  type: authenticationConstants.SIGN_IN_DSA_START,
  payload: data,
});

export const signInSSOStart = (data) => ({
  type: authenticationConstants.SIGN_IN_SSO_START,
  payload: data,
});

export const signInSuccessForMobile = (data) => ({
  type: authenticationConstants.SIGN_IN_SUCCESS_FOR_MOBILE,
  payload: data,
});

export const updateSignInStatusForMobile = () => ({
  type: authenticationConstants.UPDATE_SIGN_IN_STATUS_FOR_MOBILE,
});

export const getAccountListStart = () => ({
  type: authenticationConstants.GET_ACCOUNT_LIST_START,
});

export const getAccountListSuccess = (accounts) => ({
  type: authenticationConstants.GET_ACCOUNT_LIST_SUCCESS,
  payload: accounts,
});

export const getAccountMKT = (accounts) => ({
  type: authenticationConstants.GET_ACCOUNT_MKT,
  payload: accounts,
});

export const updateAccountListMobileSuccess = () => ({
  type: authenticationConstants.UPDATE_ACCOUNT_LIST_MOBILE_SUCCESS,
});

export const getAccountListFailure = (errorMessage) => ({
  type: authenticationConstants.GET_ACCOUNT_LIST_FAILURE,
  payload: errorMessage,
});

export const getAccountInfoStart = (accountNumber) => ({
  type: authenticationConstants.GET_ACCOUNT_INFO_START,
  payload: accountNumber,
});

export const getAccountInfoSuccess = (information) => ({
  type: authenticationConstants.GET_ACCOUNT_INFO_SUCCESS,
  payload: information,
});

export const getAccountInfoFailure = (errorMessage) => ({
  type: authenticationConstants.GET_ACCOUNT_INFO_FAILURE,
  payload: errorMessage,
});

export const getAccountNameStart = (accountNumber) => ({
  type: authenticationConstants.GET_ACCOUNT_NAME_START,
  payload: accountNumber,
});

export const getAccountNameSuccess = (accountName) => ({
  type: authenticationConstants.GET_ACCOUNT_NAME_SUCCESS,
  payload: accountName,
});

export const getAccountNameFailure = (errorMessage) => ({
  type: authenticationConstants.GET_ACCOUNT_NAME_FAILURE,
  payload: errorMessage,
});

export const signOut = () => ({
  type: authenticationConstants.SIGN_OUT,
});
